export const PLAN_MEDIA = 'planMedia';
export const ADD_CLIENT_ROUTE_NAME = 'm.bodac.clients/contacts-editPlanMedia';
export const ECRAN_PLAN_MEDIA_EDITION = 'ecranPlanMediaEdition';
export const ECRAN_PLAN_MEDIA_DETAIL = 'ecranPlanMediaDetail';
export const EXCEL_EXPORT_PLAN_MEDIA = 'planmedia';

export const SAISI = 'Saisi';
export const ENVOYE = 'Envoye';
export const ACCEPTE = 'Accepte';
export const ACCEPTE_PARTIELLEMENT = 'AcceptePartiellement';
export const REFUSE = 'Refuse';

export const PM_STATUS_TYPE = [
  { libelle: 'addEditPlanMedia.statutType.saisi', value: SAISI },
  { libelle: 'addEditPlanMedia.statutType.envoye', value: ENVOYE },
  { libelle: 'addEditPlanMedia.statutType.accepte', value: ACCEPTE },
  { libelle: 'addEditPlanMedia.statutType.acceptePartiellement', value: ACCEPTE_PARTIELLEMENT },
  { libelle: 'addEditPlanMedia.statutType.refuse', value: REFUSE },
];
